module.exports = __webpack_public_path__ + "assets/img/report.cf1506e4.svg";